import type { ExtensionFootnoteRefFragment } from "../client/generated";
import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { RefNode } from "./RefNode";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    footnoteRef: {
      setFootnoteRef: (regionId: string) => ReturnType;
    };
  }
}

type FootnoteRefOptions = {
  fragment: ExtensionFootnoteRefFragment;
};

export const FootnoteRef = Node.create<FootnoteRefOptions, undefined>({
  name: "footnoteRef",
  priority: 101,
  group: "inline",
  inline: true,
  selectable: false,
  atom: true,

  addAttributes() {
    return {
      regionId: {
        default: null,
        parseHTML: (element) => {
          const href = element.getAttribute("href");
          if (!href) return null;

          const regionId = new URL(href).hostname;
          return regionId;
        },
        renderHTML: (attributes) => {
          const href = `acdc://${attributes.regionId}`;
          return { href };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "footnote-ref[href^='acdc://']",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["footnote-ref", HTMLAttributes];
  },

  addCommands() {
    return {
      setFootnoteRef:
        (regionId) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { regionId },
          });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(RefNode);
  },
});
